import {
  Component,
  EventEmitter,
  Input,
  Output, forwardRef, Inject } from '@angular/core';

import { CompanyService } from '../../companies/company.service';

@Component({
  template: require('./transaction-center.job.row.expand.component.html')
})
export class JobRowExpandComponent {
  @Input() record: any;

  @Output() onEditClick : EventEmitter<any> = new EventEmitter();
  @Output() onLaborClick: EventEmitter<any> = new EventEmitter();
  @Output() onSMSClick  : EventEmitter<any> = new EventEmitter();

  constructor (
    @Inject(forwardRef(() => CompanyService))
    public companyService: CompanyService
  ) {}
}